import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Header from "../stories/components/Header.js";

export default function AboutPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Om Statsforvalteren"
          lead="Statsforvalteren er statens representant i fylket og har ansvar for å følge opp vedtak, mål og retningslinjer fra Stortinget og regjeringen. Vi er også et viktig bindeledd mellom kommunene og sentrale myndigheter."
        />
        <main aria-label="Artikkel innhold">
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <p>
                Statsforvalteren er administrativt underlagt Kommunal- og
                moderniseringsdepartementet (KMD), men utfører oppgaver på
                oppdrag fra de fleste departementene, direktorater og
                tilsynsmyndigheter.
              </p>
              <p>Statsforvalteren utfører også oppdrag for Kongehuset.</p>
              <p>
                Statsforvalterens samfunnsoppdrag bygger på fire myndighets- og
                ansvarsområder:
              </p>
              <ol>
                <li>
                  <strong>
                    Iverksetter av nasjonal politikk i fylket
                  </strong>
                  </li>
              </ol>
              <p>
                Statsforvalteren er iverksetter av nasjonal politikk i fylket og
                skal som sektormyndighet medvirke til iverksetting av nasjonal
                politikk.
              </p>
              <ol start="2">
                <li>
                  <strong>
                    Samordningsmyndighet
                  </strong>
                </li>
              </ol>
              <p>
                Statsforvalteren skal bidra til å samordne, forenkle og
                effektivisere den statlige virksomheten i fylket.
              </p>
              <ol start="3">
                <li>
                  <strong>
                    Rettssikkerhetsmyndighet
                  </strong>
                </li>
              </ol>
              <p>
                Statsforvalteren er klagemyndighet for kommunale enkeltvedtak og
                vedtak gjort i spesialisthelsetjenesten, og tilsynsmyndighet
                etter særlovgivningen. Statsforvalteren skal sikre
                likebehandling og rettsikkerhet for alle parter i sin
                forvaltning av lover og forskrifter.
              </p>
              <ol start="4">
                <li>
                  <strong>
                    Informasjon, kunnskapsinnhenting, initiativ og forslag
                  </strong>
                </li>
              </ol>
              <p>
                Statsforvalteren skal holde regjeringen og
                sentraladministrasjonen orientert om viktige spørsmål i fylket,
                ta de initiativ som er påkrevd, og fremme forslag til løsninger
                i den utstrekning Statsforvalteren finner det formålstjenlig.
                Statsforvalteren skal formidle informasjon til kommunale,
                fylkeskommunale og statlige organ om forhold som antas å berøre
                deres virksomhet.
              </p>
              <p>
                Mer info her: <br />
                <a href="https://www.statsforvalteren.no/portal/om-oss/">
                  www.statsforvalteren.no/portal/om-oss/
                </a>
              </p>
              
              <h2>
                Om Statsforvalterens fellestjenester 
              </h2>
              <p>
                Statsforvalterens fellestjenester (STAF) er en tjenesteleverandør og utviklingsaktør for statsforvalterne. STAF leverer digitale og administrative tjenester som er felles for alle embetene. I samarbeid med statsforvalterne utvikler og drifter vi også digitale tjenester til innbyggerne. Slik skaper vi bedre og effektive løsninger for embeter og befolkning.
              </p>
              <p>
                Les mer om STAF her: <br />
                <a href="https://www.statsforvalteren.no/staf/om-oss/">https://www.statsforvalteren.no/staf/om-oss/</a>
              </p>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}
